/**
 * Сжатие снимка перед отправкой на сервер.
 * Фото с телефона — 3–6 МБ и иногда HEIC; после сжатия ~200–500 КБ JPEG.
 * Мягкая деградация: при любой ошибке возвращаем исходный файл.
 */

const DEFAULT_MAX_SIDE = 1600;
const DEFAULT_QUALITY = 0.8;

const loadImage = (file) => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
});

export const compressImage = async (file, {
    maxSide = DEFAULT_MAX_SIDE,
    quality = DEFAULT_QUALITY,
    fileName = 'photo.jpg',
} = {}) => {
    try {
        if (!file) return file;

        // Уже маленький JPEG — не трогаем
        const isJpeg = (file.type || '').includes('jpeg');
        if (isJpeg && file.size && file.size < 900 * 1024) return file;

        const img = await loadImage(file);
        const { width, height } = img;
        if (!width || !height) return file;

        const scale = Math.min(1, maxSide / Math.max(width, height));
        const targetW = Math.round(width * scale);
        const targetH = Math.round(height * scale);

        const canvas = document.createElement('canvas');
        canvas.width = targetW;
        canvas.height = targetH;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, targetW, targetH);

        const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
        if (!blob) return file;

        // Если сжатие не помогло (редко, но бывает) — оставляем оригинал
        if (file.size && blob.size >= file.size && isJpeg) return file;

        return new File([blob], fileName, { type: 'image/jpeg', lastModified: Date.now() });
    } catch (e) {
        console.warn('[compressImage]', e);
        return file;
    }
};

/** Читабельный размер для сообщений об ошибке */
export const humanSize = (bytes) => {
    const value = Number(bytes || 0);
    if (value < 1024) return `${value} Б`;
    if (value < 1024 * 1024) return `${Math.round(value / 1024)} КБ`;
    return `${(value / 1024 / 1024).toFixed(1)} МБ`;
};